import {t} from "i18next";
import moment from "moment";

export const dateFormat = date => {
  if (!date || date == "") return null;
  // const d = new Date(date).toLocaleDateString().replaceAll(/\./g, "-").split("-").reverse().join("-");
  const d = new Date(date);
  return moment(d)?.format("DD.MM.YYYY");
};

export const dateTimeFormat = date => {
  if (!date || date == "") return null;
  // const d = new Date(date).toLocaleDateString().replaceAll(/\./g, "-").split("-").reverse().join("-");
  const d = new Date(date);
  return moment(d)?.format("DD.MM.YYYY HH:mm:ss");
};

export const fullDateFormat = date => {
  if (!date || date == "") return null;

  const d = new Date(date);
  return moment(d, "YYYY-MM-DDTHH:mm:ss.sssZ");
};

export const dateUnformat = date => {
  if (!date || date == "") return null;

  return moment(date).toDate();
};

export const dateTimeUnformatToUnix = date => {
  if (!date || date == "") return null;

  return moment(date, "DD.MM.YYYY hh:mm:ss").unix();
};

export const timeFormat = date => {
  if (!date || date == "") return null;
  const d = new Date(date);
  return moment(d)?.format("hh:mm:ss");
};

export const deadlineStatus = date => {
  if (!date) return null;

  const due = moment(date);
  const now = moment();
  const diff = due.diff(now, "days");

  if (diff > 0) {
    return t("deadline.in", {count: diff});
  } else if (diff === 0) {
    return t("deadline.today");
  } else {
    return t("deadline.expired", {count: Math.abs(diff)});
  }
};
